import {
    FORGOT_PASSWORD_SENT_OTP,
    FORGOT_PASSWORD_CHECK_OTP,
    CHANGED_PASSWORD,
} from "../actions";

const initialState = {
    forgotData: null,
    verifyEmail: null,
    checkVerify: false,
    loading: true,
};

const forgotPasswordReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FORGOT_PASSWORD_SENT_OTP:
            return {
                ...state,
                forgotData: payload,
                checkVerify: true,
                loading: false,
            };
        case FORGOT_PASSWORD_CHECK_OTP:
            return {
                ...state,
                verifyEmail: payload,
                checkVerify: true,
                loading: false,
            };
        case CHANGED_PASSWORD:
            return {
                ...state,
                forgotData: null,
                verifyEmail: null,
                checkVerify: false,
                loading: false,
            };

        default:
            return state;
    }
};

export default forgotPasswordReducer;
